import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { Card, Space, Skeleton } from 'antd'
import './index.css'
import '../../../assets/css/common.css'
import { SoundOutlined } from '@ant-design/icons'
import ReactEcharts from 'echarts-for-react'
import * as echarts from 'echarts';
import { _world } from './world';
import 'echarts-wordcloud'
import mapdata from '../graph/data/mockdata_map.json'

class Tool extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mainCountryOption: {},
            yidaiOption: {},
            mapOption: {},
            detail: {},
            selCountry: '美国',
            genderOption: {},
            partyOption: {}
        }
        this.mainCountry = React.createRef()
        this.yidai = React.createRef()
        this.mapInstance = React.createRef()
        this.gender = React.createRef()
        this.party = React.createRef()
    }
    onChartClick (param) {
        if (param.data && param.data.detail) {
            this.setState({
                detail: param.data.detail,
                selCountry: param.data.name
            })
            let cityName = param.data.name
            if (mapdata[cityName] && mapdata[cityName].gender) {
                this.drawGenderPie(cityName)
            }
            if (mapdata[cityName] && mapdata[cityName].party) {
                this.drawRose(cityName)
            }
        } else {
            this.setState({
                detail: {},
                selCountry: ''
            })

        }
    }
    getRandomNumber (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
    }
    drawGenderPie (city) {
        const genderOption = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}\n{d}%',
            },
            color: ['#4874cb', '#ee822f'],
            series: [
                {
                    name: '性别比例',
                    type: 'pie',
                    radius: '95%',
                    top: 0,
                    data: mapdata[city].gender,
                    label: {
                        formatter: '{b}\n{d}%',
                        lineHeight: 18,
                        position: 'inner',
                        fontSize: 14
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        }
        this.setState({
            genderOption: genderOption,
        })
    }
    drawRose (city) {
        const partyOption = {
            legend: {
                top: 'top',
                align: 'left',
                formatter: function (name) {
                    let limitlength = 40
                    if (name.length > limitlength) {
                        return name.substring(0, limitlength - 1) + '...'
                    } else {
                        return name
                    }
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} \n{c}',
            },
            series: [
                {
                    name: 'Party Status',
                    type: 'pie',
                    radius: [30, 99],
                    center: ['50%', '62%'],
                    roseType: 'area',
                    minAngle: 5,
                    itemStyle: {
                        borderRadius: 8,
                    },
                    label: {
                        position: 'outside',
                    },
                    labelLine: {
                        show: true,
                        length: -10,
                    },
                    // emphasis: {
                    //   itemStyle: {
                    //     shadowBlur: 10,
                    //     shadowOffsetX: 0,
                    //     shadowColor: 'rgba(0, 0, 0, 0.5)',
                    //   },
                    // },
                    data: mapdata[city].party
                },
            ],
        }
        this.setState({
            partyOption: partyOption,
        })
    }
    componentDidMount () {
        //性别饼图
        // console.log(mapdata)
        this.drawGenderPie('美国')
        //党派玫瑰图
        this.drawRose('美国')
        //设置地图显示
        const mapOption = {
            visualMap: {
                min: 1000,
                max: 5000,
                show: false,
                seriesIndex: [0],
                inRange: {
                    color: ["#bdfcc9", "#4169e1"],
                },
            },
            series: [
                {
                    type: 'map',
                    map: 'world', // 设置使用世界地图
                    zoom: 1.2,
                    roam: true, // 开启鼠标缩放和平移漫游
                    label: {
                        show: false // 显示标签
                    },
                    itemStyle: {
                        areaColor: '#e4f5fa'
                    },
                    data: [
                        // 西方主要
                        { name: '美国', value: 4000, detail: { yihui: 4857, yiyuan: 2515, start: '2013-1-1' } },
                        { name: '英国', value: 4000, detail: { yihui: 18199, yiyuan: 650, start: '2015-1-1' } },
                        { name: '俄罗斯', value: 4000, detail: { yihui: 5448, yiyuan: 584, start: '2016-1-1' } },
                        { name: '法国', value: 4000, detail: { yihui: 12511, yiyuan: 922, start: '2017-1-1' } },
                        { name: '德国', value: 4000, detail: { yihui: 5761, yiyuan: 913, start: '2001-1-1' } },
                        { name: '加拿大', value: 4000, detail: { yihui: 13353, yiyuan: 338, start: '2005-1-1' } },
                        // 一带一路
                        { name: '巴基斯坦', value: 1200, detail: { yihui: 3192, yiyuan: 318, start: '2013-1-1' } },
                        { name: '马来西亚', value: 1200, detail: { yihui: 1418, yiyuan: 287, start: '1965-1-1' } },
                        { name: '新加坡', value: 1200, detail: { yihui: 28727, yiyuan: 103, start: '1970-1-1' } },
                        { name: '土耳其', value: 1200, detail: { yihui: 3823, yiyuan: 580, start: '1988-1-1' } },
                        { name: '新西兰', value: 1200, detail: { yihui: 19152, yiyuan: 121, start: '2000-1-1' } },
                        { name: '印度', value: 1200, detail: { yihui: 7933, yiyuan: 492, start: '2009-1-1' } },
                        { name: '波兰', value: 1200, detail: { yihui: 160, yiyuan: 460, start: '2013-1-1' } },
                        { name: '南非', value: 1200, detail: { yihui: 3148, yiyuan: 482, start: '2018-1-1' } },
                        { name: '奥地利', value: 1200, detail: { yihui: 56254, yiyuan: 259, start: '2018-1-1' } }
                    ]
                }
            ]
        };

        echarts.registerMap('world', {
            "type": "FeatureCollection",
            "crs": {
                "type": "name",
                "properties": {
                    "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
                }
            },
            "features": _world,
            "UTF8Encoding": true
        });

        this.setState({
            mapOption: mapOption
        })

        //设置国家高亮
        // this.mapInstance.getEchartsInstance().dispatchAction({
        //   type: "click",
        //   geoName: 'China',//地图层
        //   name: 'Brazil'
        // });

        //主要国家柱状图
        const mainCountryOption = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                'top': 10,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLabel: {
                    rotate: 30,//倾斜度 -90 至 90 默认为0
                }
            },
            yAxis: {
                type: 'category',
                data: ['美国', '英国', '俄罗斯', '欧洲', '法国', '德国', '加拿大']
            },
            series: [
                {
                    name: '议会数量',
                    type: 'bar',
                    data: [4857, 18199, 5448, 7747, 12511, 5761, 13353]
                },
                {
                    name: '议员数量',
                    type: 'bar',
                    data: [2515, 650, 584, 704, 922, 913, 338]
                }
            ]
        };
        this.setState({
            mainCountryOption: mainCountryOption,
        })
        //一带一路柱状图
        const yidaiOption = {
            color: ['#4874cb', '#ee822f'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                'top': 10,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLabel: {
                    rotate: 30,//倾斜度 -90 至 90 默认为0
                }
            },
            yAxis: {
                type: 'category',
                data: ['巴基斯坦', '马来西亚', '新加坡', '土耳其', '新西兰', '印度', '波兰', '南非', '奥地利']
            },
            series: [
                {
                    name: '议会数量',
                    type: 'bar',
                    data: [3192, 1418, 28727, 3823, 19152, 7933, 160, 3148, 56254]
                },
                {
                    name: '议员数量',
                    type: 'bar',
                    data: [318, 287, 103, 580, 121, 492, 460, 482, 259]
                }
            ]
        };
        this.setState({
            yidaiOption: yidaiOption,
        })
    }

    render () {
        const onEvents = {
            'click': this.onChartClick.bind(this)
        }
        const mapName = {
            "United States": "美国",
            "United Kingdom": "英国",
            "Russia": "俄罗斯",
            "France": "法国",
            "Germany": "德国",
            "Canada": "加拿大",
            "Pakistan": "巴基斯坦",
            "Malaysia": "马来西亚",
            "Singapore": "新加坡",
            "Turkey": "土耳其",
            "New Zealand": "新西兰",
            "India": "印度",
            "Poland": "波兰",
            "South Africa": "南非",
            "Austria": "奥地利"
        }
        return (
            <div className="graph-container">
                <div style={{ display: 'flex', gap: '16px', height: '100%' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            flex: 3.5,
                        }}
                    >

                        <div className="g-card" style={{ height: '100%' }}>
                            <div className="panelTitle">
                                <SoundOutlined /> 西方主要国家
                            </div>
                            <div className="panelContent" style={{ flex: 1 }}
                                ref={this.mainCountry}>
                                <ReactEcharts
                                    option={this.state.mainCountryOption}
                                    theme="ThemeStyle"
                                    style={{
                                        height: 319,
                                        width: '98%'
                                    }}
                                />
                            </div>
                            <div className="panelTitle">
                                <SoundOutlined /> 一带一路国家
                            </div>
                            <div className="panelContent" style={{ flex: 1 }} ref={this.yidai}>
                                <ReactEcharts
                                    option={this.state.yidaiOption}
                                    theme="ThemeStyle"
                                    style={{
                                        height: 319,
                                        width: '98%'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            width: '55%',
                            flexShrink: 0
                        }}
                    >
                        <div
                            className="g-card"
                            style={{
                                height: '100%',
                                border: 'none',
                                backgroundColor: '#f5f7fa',
                            }}
                        >
                            <div className="panelTitle">
                                <SoundOutlined /> <span style={{ color: '#eb4b0b' }}>{this.state.selCountry}</span> 议会/议员数据地图
                            </div>
                            <div className="panelContent" style={{ flex: 1 }} >
                                <ReactEcharts option={this.state.mapOption} theme="ThemeStyle" onEvents={onEvents} style={{ height: 650 }} ref={(e) => { this.mapInstance = e; }} />
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            flex: 3.5
                        }}
                    >
                        <div className="g-card" style={{ height: '100%', flexShrink: 1 }}>
                            <div className="panelTitle">
                                <SoundOutlined /> 性别比例
                            </div>
                            <div
                                className="panelContent"
                                style={{ flex: 1 }}
                                ref={this.gender}
                            >
                                <ReactEcharts
                                    option={this.state.genderOption}
                                    theme="ThemeStyle"
                                    style={{
                                        height: 250,
                                        width: '98%'
                                    }}
                                />
                            </div>
                            <div className="panelTitle" style={{ marginTop: 7 }}>
                                <SoundOutlined /> 党派情况
                            </div>
                            <div
                                className="panelContent"
                                style={{ flex: 1 }}
                                ref={this.party}
                            >
                                <ReactEcharts
                                    option={this.state.partyOption}
                                    theme="ThemeStyle"
                                    style={{
                                        paddingTop: 5,
                                        height: 380,
                                        width: '98%'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Tool
